import { api } from './client';

export const uploadPathApi = {
  preview: (projectId, { batchIds = [] } = {}) => (
    api.post(`/projects/${projectId}/docs-scene-import/preview`, {
      batch_ids: batchIds,
    })
  ),
  importScenes: (storyId, { projectId, batchIds = [], scenes } = {}) => (
    api.post(`/stories/${storyId}/docs-scene-import`, {
      project_id: projectId,
      batch_ids: batchIds,
      scenes,
    })
  ),
  view: (storyId) => api.get(`/stories/${storyId}/upload-path`),
  ensureHeaders: (storyId) => api.post(`/stories/${storyId}/upload-path/headers`, {}),
  mapScene: (storyId, { sceneId, sequenceId = null }) => (
    api.post(`/stories/${storyId}/upload-path/map`, {
      scene_id: sceneId,
      sequence_id: sequenceId,
    })
  ),
  setPlanMode: (storyId, mode) => (
    api.post(`/stories/${storyId}/upload-path/plan-mode`, { mode })
  ),
  setPurpose: (storyId, { sceneId, purpose }) => (
    api.post(`/stories/${storyId}/upload-path/purpose`, {
      scene_id: sceneId,
      purpose,
    })
  ),
  renameScene: (storyId, { sceneId, name }) => (
    api.post(`/stories/${storyId}/upload-path/name`, {
      scene_id: sceneId,
      name,
    })
  ),
};
